import React from 'react'
import { Container, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LeftArrow, LogoutIcon, RightArrow } from '../../../Assets/svgIcons';
import moment from 'moment';
import { formatCommaNumbers } from '../../../Utils/common.utils';

const DepositWithdraw = ({txnreportData}) => {
  return (
    <>
      <section className="page_design">
        <Container>
          {/* <div className="backbtn mb-3">
            <Link to="/account"><span><LeftArrow /></span> Back</Link>
          </div> */}
          <div className="page_design_in">
            <div className="page_design_head">
              <h2>Deposit/Withdraw</h2>
              {/* <div className="page_design_head_right">
                <div className="page_design_head_right_box">
                  <button className='btn-style'>
                    <span><LogoutIcon /></span> Export
                  </button>
                </div>
              </div> */}
            </div>
            <div className="page_design_body">
              <Table responsive>
                <thead>
                  <tr>
                    <th></th>
                    <th>Sr No.</th>
                    <th>Date</th>
                    <th>Deposit/ Withdraw Amount </th>
                    <th>Opening Balance</th>
                    <th>Closing Balance</th>
                    <th>Transaction Type</th>
                    {/* <th>Status</th> */}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {txnreportData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td></td>
                        <td>{index + 1}</td>
                        
                        <td>{moment(item.created_at).format('DD-MM-YYYY')}</td>
                        <td>$ {item.event_type==="WithDraw"&& "-"}{formatCommaNumbers(item.amount)}</td>
                        <td>${formatCommaNumbers(item.opening_balance)}</td>
                        <td>${formatCommaNumbers(item.closing_balance)}</td>
                        <td>{item.event_type}</td>
                        {/* <td>
                          <span className={`green_text ${item.status === "Pending" ? "yellow_text" : ""}`}>{item.status}</span>
                        </td> */}
                        <td></td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}

export default DepositWithdraw